var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dark-mode"},[_c('BaseIconTitle',{attrs:{"title":'Dark mode',"material-icon":'dark_mode'}}),_c('BaseSwitch',{nativeOn:{"click":function($event){return _vm.changeTheme()}},model:{value:(_vm.mode),callback:function ($$v) {_vm.mode=$$v},expression:"mode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }